import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { GlobalState } from './types';

export const actions: ActionTree<GlobalState, RootState> = {
    setLang({ commit }: any, lang: string) {
        commit('setLangSuccess', lang);
    },
};
